import './style.css'
import './plugins/axios'
import Vue from 'vue'
import './plugins/vuetify'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import './plugins/firebase'
import CKEditor from '@ckeditor/ckeditor5-vue'
import lineClamp from 'vue-line-clamp'
import smoothscroll from 'smoothscroll-polyfill'
import SocialSharing from 'vue-social-sharing';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret, faFacebook, faTwitter, faWhatsapp)

Vue.component('font-awesome-icon', FontAwesomeIcon)

// kick off the polyfill!
smoothscroll.polyfill();


new Vue({
    router,
    render: h => h(App)
}).$mount('#app')

Vue.use(CKEditor)
Vue.use(lineClamp)
Vue.use(SocialSharing);
